import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrxServicesAchPage } from './trxservices-ach.page';

const routes: Routes = [
  {
    path: '',
    component: TrxServicesAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrxServicesAchPageRoutingModule {}
